import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import primaryComponents from "../../../primaryComponents";
import useDownloadStatement from "./useDownloadStatement";
import Validation from "./Validation";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

const StoreWalletDownloadStatement = ({
  closeWidget,
  type = "store",
  customer,
  rebatesAccount,
  selectedStoreId,
  storeWallets,
}) => {
  const {
    statementFormat,
    setStatementFormat,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleDownloadStatement,
    downloadStatement,
    downloadDebtorStatement,
    downloadLedgerAccountStatement,
    setWalletId,
    setSelectedStore,
    walletId,
    ledgerAccountsList,
    selectedStore,
    bankAccount,
    setSelectedBank,
    selectedBank,
    setRebatesDetails,
  } = useDownloadStatement({ closeWidget, type, customer, selectedStoreId });
  const {
    control,
    register,
    formState: { errors },
    trigger,
    handleSubmit,
  } = Validation(
    statementFormat,
    startDate,
    endDate,
    walletId,
    type,
    selectedStore,
    selectedBank,
  );

  return (
    <div className={globalStyles.pageColumnGaps} style={{ minHeight: "100%" }}>
      <div>
        <primaryComponents.Button
          classNames={"btn btn--outline smallBtn"}
          onClick={closeWidget}
        >
          <FontAwesomeIcon icon="angle-left" style={{ fontSize: "15px" }} />
        </primaryComponents.Button>
      </div>

      <div>
        <h4>Statement of Account</h4>
        <p>
          You can choose how you&apos;d like to receive your account statement
          from the options below:
        </p>
      </div>

      <form
        className={globalStyles.pageColumnGaps}
        style={{ gap: "10px" }}
        id="walletStatementOfAccount"
        onSubmit={handleSubmit((values) => handleDownloadStatement(values))}
      >
        {!(type === "debtor" || type === "cash" || type === "bank") && (
          <primaryComponents.SelectFieldV2
            control={control}
            idKey={"id"}
            nameKey={"name"}
            name="walletId"
            isRequired={true}
            value={
              type === "ledger" ? "Select rebate account" : "Select wallet"
            }
            classNames="wallet-select"
            label={
              type === "ledger" ? "Select rebate account" : "Select wallet"
            }
            options={
              type === "ledger"
                ? rebatesAccount?.map((item) => ({
                    id: item?.supplier?.id,
                    name: item?.supplier?.name,
                  }))
                : storeWallets?.data
                    ?.filter((data) => data?.tag)
                    ?.map((data) => ({
                      id: data?.id,
                      name: (
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ gap: "30px" }}
                        >
                          <div>{data?.tag}</div>
                          <div
                            className={`${data?.is_subwallet ? "gray--squared" : "gray--primary"}`}
                          >
                            {data?.is_subwallet
                              ? "Sub-wallet"
                              : "Primary Wallet"}
                          </div>
                        </div>
                      ),
                    }))
            }
            onChange={(value) => {
              if (type === "ledger") {
                const selectedSupplier = rebatesAccount?.find(
                  (item) => item?.supplier?.id === value,
                );
                setRebatesDetails(selectedSupplier?.id);
              }
              setWalletId(value);
            }}
            errorMessage={errors.walletId}
          />
        )}
        {type === "cash" && (
          <primaryComponents.SelectFieldV2
            control={control}
            name="selectedStore"
            isRequired={true}
            label={"Select store"}
            options={ledgerAccountsList?.data?.map((store) => ({
              id: store?.store?.id,
              name: store?.store?.name,
            }))}
            onChange={(value) => {
              setSelectedStore(value);
            }}
            value={"Select store"}
            errorMessage={errors.selectedStore}
            idKey="id"
            nameKey="name"
            floatError={false}
            classNames="store-name"
            isSearchable={false}
          />
        )}
        {type === "bank" && (
          <primaryComponents.SelectFieldV2
            control={control}
            name="selectedBank"
            label={"Select Bank"}
            isRequired={true}
            errorMessage={errors.selectedBank}
            options={bankAccount?.data.map((bank) => ({
              id: bank?.id,
              name: (
                <div>
                  <div>{bank?.account_name}</div>
                  <span className="small-text-size">
                    {bank?.bank_name} ({bank?.account_number})
                  </span>
                </div>
              ),
            }))}
            idKey="id"
            nameKey="name"
            value={"Select Bank"}
            onChange={(value) => {
              setSelectedBank(value);
            }}
            floatError={false}
            classNames="bank-name"
            isSearchable={false}
          />
        )}
        <div>
          <label className="mb-1">
            <span className="error--text">*</span>File Format
          </label>
          <div className="mb-3">
            <primaryComponents.BoxedRadioInput
              control={control}
              name="statementFormat"
              value={statementFormat}
              id="PDF"
              isChecked={statementFormat === "PDF"}
              setRadioValue={() => {
                setStatementFormat("PDF");
              }}
            >
              <span className="font-weight-semibold">PDF</span>
            </primaryComponents.BoxedRadioInput>
          </div>
          <div>
            <primaryComponents.BoxedRadioInput
              control={control}
              name="statementFormat"
              value={statementFormat}
              id="CSV"
              isChecked={statementFormat === "CSV"}
              setRadioValue={() => {
                setStatementFormat("CSV");
              }}
            >
              <span className="font-weight-semibold">Excel</span>
            </primaryComponents.BoxedRadioInput>
          </div>
        </div>
        <div>
          <label className="mb-1">
            <span className="error--text">*</span>Date Range
          </label>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ width: "max-content" }}>
              <primaryComponents.DateInputV2
                control={control}
                name="startDate"
                value={startDate}
                classNames="white"
                isRequired={true}
                errorMessage={errors.startDate}
                onChange={({ target: { value } }) => {
                  setStartDate(value);
                }}
                onKeyUp={() =>
                  errors.startDate !== undefined && trigger("startDate")
                }
                register={register}
              />
            </div>
            <span>To</span>
            <div style={{ width: "max-content" }}>
              <primaryComponents.DateInputV2
                control={control}
                name="endDate"
                value={endDate}
                classNames="white"
                isRequired={true}
                errorMessage={errors.endDate}
                onChange={({ target: { value } }) => {
                  setEndDate(value);
                }}
                onKeyUp={() =>
                  errors.endDate !== undefined && trigger("endDate")
                }
                register={register}
              />
            </div>
          </div>
        </div>
      </form>

      <primaryComponents.Button
        classNames="btn btn--primary mt-auto"
        isLoading={
          downloadStatement.isLoading ||
          downloadDebtorStatement.isLoading ||
          downloadLedgerAccountStatement.isLoading
        }
        loadingText="Downloading..."
        isDisabled={
          downloadStatement.isLoading ||
          downloadDebtorStatement.isLoading ||
          downloadLedgerAccountStatement.isLoading
        }
        type="submit"
        form="walletStatementOfAccount"
      >
        Download
      </primaryComponents.Button>
    </div>
  );
};

export default StoreWalletDownloadStatement;
